import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';

export const AccountOpeningV2UncommonSituationsStepLayout = ({ navigateToLink }) => {
  const { onSubmit, saving, resource } = useMetaLayoutContext();
  return (
    <FDStack spacing={3} direction="column">
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />
      <MetaLayoutRemainingFields noAccordion />
      <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
        <WizardBackButtonRel overrideOnClick={(_, rel) => navigateToLink(rel.link('related'))} resource={resource} />
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label="Save and continue"
          loading={saving}
          onClick={onSubmit}
        />
      </FDStack>
    </FDStack>
  );
};

AccountOpeningV2UncommonSituationsStepLayout.defaultProps = {
};

AccountOpeningV2UncommonSituationsStepLayout.propTypes = {
  navigateToLink: PropTypes.func.isRequired,
};
